import SkeletonBase from './SkeletonBase';

const SkeletonBox = ({
  width = '100%',
  height = 100,
  borderRadius = 'var(--radius-md)',
  className = '',
  style = {},
  variant,
  ...props
}) => {
  return (
    <SkeletonBase
      width={width}
      height={height}
      borderRadius={borderRadius}
      className={`skeleton-box ${className}`}
      style={style}
      variant={variant}
      {...props}
    />
  );
};

export default SkeletonBox;
